import { defineComponent as _defineComponent } from 'vue'
import type { Contract } from '@/core/components/composed/list/MultipleContracts.vue';
import { useContext } from '@nuxtjs/composition-api';
import { ACTIONS as ACTIONS_USER_FEEDBACK } from '~/store/affility/user/feedback/names';
import { ACTIONS as ACTIONS_WEB3_TOKENS } from '~/store/affility/web3/tokens/names';
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";

interface Props {
    direction?: 'column' | 'row',
    contracts: Contract[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenImport',
  props: {
    direction: { default: 'row' },
    contracts: { default: () => [] }
  },
  setup(__props: any) {

const { contracts, direction } = __props as { direction: 'column' | 'row', contracts: Contract[] };



const { store, i18n } = useContext();
const $t = i18n.t.bind(i18n);

const addTokenToWallet = store.dispatch.bind(null, `affility/web3/tokens/${ACTIONS_WEB3_TOKENS.WATCH_ASSET}`);

const showSuccess = store.dispatch.bind(null, `affility/user/feedback/${ACTIONS_USER_FEEDBACK.SHOW_SUCCESS_MODAL}`);
const showError = store.dispatch.bind(null, `affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`);

const handleContractClick = async (contract: Contract) => {
    if (!contract.walletInfo) {
        return;
    }
    try {
        await addTokenToWallet({ asset: contract.walletInfo, network: contract.network });
        showSuccess({
            desc: $t('address_add_to_wallet_success'),
            buttonVisible: false,
            timeout: 3000,
        });
    } catch (msg) {
        showError({
            description: $t(msg),
        });
    }
};


return { __sfc: true,contracts, direction, store, i18n, $t, addTokenToWallet, showSuccess, showError, handleContractClick }
}

})